import { Skeleton } from '@chakra-ui/react';
import { createColumnHelper } from '@tanstack/react-table';

export type TBatchErrorsDataTableData = {
  primaryKey: string | number,
  recordId: string,
  responseCode: string,
  responseLabel: string,
  oracleError: string,
  errorDescription: string,
};
 

type Props = {
  isLoading: boolean | undefined,
};

const columnHelper = createColumnHelper<TBatchErrorsDataTableData>();

export function getBatchErrorsDataTableColumns({ isLoading }: Props) {
  return [
    columnHelper.accessor('recordId', {
      id: 'recordId',
      header: 'Id Enregistrement',
      cell: (props) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            {props.getValue()}
          </Skeleton>
        );
      },
    }),

    columnHelper.accessor('responseCode', {
      id: 'responseCode',
      header: 'Code Réponse',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('responseLabel', {
      id: 'responseLabel',
      header: 'Libellé Réponse',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),

    columnHelper.accessor('oracleError', {
      id: 'oracleError',
      header: 'Erreur Oracle',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
    columnHelper.accessor('errorDescription', {
      id: 'errorDescription',
      header: 'Description Erreur',
      cell: (props) => {
        return <Skeleton isLoaded={!isLoading}>{props.getValue()}</Skeleton>;
      },
    }),
    
  ];
}